import type { EdgeMarkerType } from '@xyflow/react';
import { type Edge, MarkerType } from '@xyflow/react';

import { baseColors } from '@polyai/ui/styles/config/colors';

import type { FeatureFlag } from 'hooks/useFeatureSwitch/useIsFeatureOn';
export enum NodeType {
  STEP_NODE = 'stepNode',
  NO_CODE_STEP_NODE = 'noCodeStepNode',
  FUNCTION_STEP_NODE = 'functionStepNode',
  CONDITION_NODE = 'conditionNode',
  EXIT_FLOW_NODE = 'exitFlowNode',
  NEXT_STEP_SELECTION_NODE = 'nextStepSelectionNode',
  FUNCTION_STEP_CONDITION_NODE = 'functionStepConditionNode',
  STEP_CONDITION_NODE = 'stepConditionNode',
  ADVANCED_STEP_CONDITION_NODE = 'advancedStepConditionNode',
}

export const DEFAULT_NEW_STEP_NAME = 'New step';

export const DRAG_HANDLE_CLASS = 'stepDragHandle';

export const HANDLE_SIZE = 12;
export const Z_INDEXES = {
  sidebar: 18,
  controls: 15,
  node: {
    interactable: 12,
    configuration: 10,
  },
};

export const NEXT_STEP_SELECTION_NODE_WIDTH = 200;

// NOTE: Not all ASR biasing toggles got feature flags, those introduced after asr biasing panel v1
// were given a feature flag.
export const ASR_BIASING_TOGGLES_FEATURE_FLAGS: Record<string, FeatureFlag> = {
  address: 'address_asr_biasing',
};

export const CONFIGURATION_PANEL_WIDTH = 375;

export const DTMF_INTER_DIGIT_TIMEOUT_SLIDER_WIDTH = '200px';

export const INTER_DIGIT_TIMEOUT_DEFAULT_VALUE = 3;

// these are used to perform a smooth scroll upon badge click in ActiveConfigurations component
export const DTMF_CONTAINER_ID = 'dtmf-configuration-container';

export const ASR_BIASING_CONTAINER_ID = 'asr-biasing-configuration-container';

export const STEP_NODE_WIDTH = 500;
export const FUNCTION_STEP_NODE_WIDTH = 300;

export const NODE_CONNECTION_OFFSETS = {
  noCodeStep: { x: 0, y: 350 },
  condition: { x: 189, y: 200 },
  exitFlow: { x: 183, y: 500 },
  advancedStep: { x: 0, y: 350 },
} as const;

export const SHARED_EDGE_CONFIG: Partial<Edge> = {
  type: 'custom',
  style: {
    color: baseColors.newGrey['60'],
  },
} as const;

const CONNECTION_ARROW_SIZE = 16;

export const EDGE_CONFIG_MARKER: EdgeMarkerType = {
  type: MarkerType.ArrowClosed,
  width: CONNECTION_ARROW_SIZE,
  height: CONNECTION_ARROW_SIZE,
  color: SHARED_EDGE_CONFIG.style?.color,
};
